export const config = {
  apiEndpoint: "http://localhost:5002",
  //apiEndpoint: "https://admin.findlocalpetservices.com",

  baseNodeapiUrl: "http://localhost",
};
